import { render, staticRenderFns } from "./ModalAddArticlev2.vue?vue&type=template&id=00ac0ac3&"
import script from "./ModalAddArticlev2.vue?vue&type=script&lang=js&"
export * from "./ModalAddArticlev2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports